/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useMemo,
} from "react";
import { Container, Row, Col } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useHistory, useParams } from "react-router-dom";
import { getFunds } from "../stores/services/funds.service";
import { getNewChartsOfAccountsByFund } from "../stores/services/chatofaccounts.service";
import { getLedgerAccounts } from "../utils/customFunction";
import { addMegaTransaction } from "../stores/services/beta-transaction.service";
import { numberWithCommas } from "./../utils/customFunction";
import { ThemeContext } from "../contexts/ThemeContext";
import { useSelector } from "react-redux";
import Select from "react-select";
import NumberFormat from "react-number-format";
import moment from "moment";
import { getAllCompanies } from "../stores/services/company.service";
import { useCustomStylesDropDown } from "../assets/css/customStyle";
import { IoIosClose } from "react-icons/io";
import {
  getAllProvidentFunds,
  getProvidentFundProfitSummary,
} from "../stores/services/provident-funds.service";
import { pf_profit_inputs } from "../utils/ui_data";
import { profitPreviewAPI } from "../stores/services/profit-preview.service";
import ProfitPreviewCard from "../components/ProfitPreviewCard";
import { getInvestmentTransactionById } from "../stores/services/transactions.service";

interface FieldValues {
  email: any;
  txnr_type: any;
  amc_code: any;
  fund_code: any;
  instruction_date: any;
  execution_date: any;
  executed_date: any;
  fund_account: any;
  reinvest: any;
  account_title: any;
  period: any;
  account_no: any;
  bank: any;
  branch: any;
  mode_of_payment: any;
  payment_type: any;
  instrument_no: any;
  instrument_type: any;
  instrument_date: any;
  realized_date: any;
  realized: any;
  gross_amount: any;
  net_amount: any;
  sale_date: any;
  issue_date: any;
  detail: any;
  settlement_by: any;
  settlement_date: any;
  ledgers: any;
}

const PFProfitTransaction = (props: any) => {
  const { id } = useParams<{ id?: string }>();

  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const history = useHistory();
  const context = useContext(ThemeContext);
  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const loggedInUser = JSON.parse(sessionStorage.getItem("loggedInUser") || "");

  const [Loading, setLoading] = useState(false);
  const [accFundLoading, setAccFundLoading] = useState<any>(false);

  // Data States
  const [allFunds, setAllFunds] = useState<any>([]);
  const [companyOptions, setCompanyOptions] = useState<any[]>([]);

  // Selection States
  const [companyName, setCompanyName] = useState<any>(null);
  const [fund, setFund] = useState("");

  // Calculation States
  let today: any = new Date();
  let dd = String(today.getDate()).padStart(2, "0");
  let mm = String(today.getMonth() + 1).padStart(2, "0");
  let yyyy = today.getFullYear();
  today = yyyy + "-" + mm + "-" + dd;

  const [date, setDate] = useState<any>(today);
  const [settlementDate, setSettlementDate] = useState<any>(
    moment(today, "YYYY-MM-DD").format("YYYY-MM-DD")
  );
  const [profitMonth, setProfitMonth] = useState<any>(
    moment().format("YYYY-MM")
  );

  const [grossProfit, setGrossProfit] = useState<any>("");
  const [ledgersPayload, setLedgersPayload] = useState<any[]>([]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [fields, setFields] = useState<FieldValues>({
    email: email,
    txnr_type: "fundprofit",
    amc_code: loggedInUser.amc_code,
    fund_code: "",
    reinvest: "false",
    instruction_date: moment(date).format("YYYY-MM-DD"),
    execution_date: moment(date).format("YYYY-MM-DD"),
    executed_date: moment(date).format("YYYY-MM-DD"),
    fund_account: "",
    account_title: "",
    account_no: "",
    bank: "",
    branch: "",
    mode_of_payment: "",
    payment_type: "",
    instrument_no: "",
    instrument_type: "",
    instrument_date: moment(date).format("YYYY-MM-DD"),
    realized_date: moment(date).format("YYYY-MM-DD"),
    realized: "true",
    gross_amount: "",
    net_amount: "",
    period: sessionStorage.getItem("active_period") || "",
    sale_date: moment(date).format("YYYY-MM-DD"),
    issue_date: moment(date).format("YYYY-MM-DD"),
    detail: "",
    settlement_by: "",
    settlement_date: moment(settlementDate).format("YYYY-MM-DD"),
    ledgers: "",
  });

  const [total, setTotal] = useState<{
    overall_employee_contribution: number;
    overall_employer_contribution: number;
    overall_profit: number;
    overall_total: number;
  }>({
    overall_employee_contribution: 0,
    overall_employer_contribution: 0,
    overall_profit: 0,
    overall_total: 0,
  });

  const [fundAccount, setFundAccount] = useState<any>({});
  const [counterFundLoading, setCounterFundLoading] = useState(false);
  const [chartOfAccounts, setChartOfAccounts] = useState<any>([]);
  const [fundAccountsMap, setFundAccountsMap] = useState<any[]>();

  const [totalDebit, setTotalDebit] = useState("0");
  const [totalCredit, setTotalCredit] = useState("0");
  const [balance, setBalance] = useState("0");
  const [errorProfitMonth, setErrorProfitMonth] = useState("");
  const [profitInputs, setProfitInputs] = useState<any>({});
  const { customStyles } = useCustomStylesDropDown();

  const [previewSessionId, setPreviewSessionId] = useState<string>("");
  const [previewData, setPreviewData] = useState<any[]>([]);
  const [previewSummary, setPreviewSummary] = useState<any>(null);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [investmentOptions, setInvestmentOptions] = useState<any>();
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [loadingTransactionData, setLoadingTransactionData] = useState(false);
  // Fetch Chart of Accounts for the fund
  const getCounterFundAccountByFundName = async (fund_code: string) => {
    setCounterFundLoading(true);
    try {
      let response = await getNewChartsOfAccountsByFund(
        email,
        amc_code,
        fund_code
      );
      if (response.data.status === 200) {
        setChartOfAccounts(response?.data?.data?.main_family);
      }
    } catch (error) {
      console.error("Error fetching chart of accounts", error);
    } finally {
      setCounterFundLoading(false);
    }
  };

  //  Auto-select Collection account
  const findCollectionAccount = (accounts: any[]) => {
    const collectionAccount = accounts.find(
      (acc) =>
        acc.account_purpose &&
        Array.isArray(acc.account_purpose) &&
        acc.account_purpose.includes("Collection")
    );

    setFundAccount(collectionAccount);
  };

  //  Fetch accounts for a specific fund
  const fetchAccountsForFund = async (fundCode: string) => {
    try {
      let response = await getNewChartsOfAccountsByFund(email, amc_code, fund);
      let temp: any = [];
      if (response.data.status === 200) {
        setChartOfAccounts(response?.data?.data?.main_family);
        const counterAccounts = getLedgerAccounts(
          response?.data?.data?.main_family[0].family[3].sub_family
        );
        temp = counterAccounts;
        temp.unshift({
          value: "Other",
          label: "Other",
        });

        setCounterFundLoading(false);
      } else {
        temp = [
          {
            value: "Other",
            label: "Other",
          },
        ];
        setCounterFundLoading(false);
      }

      const accounts = temp.map((acc: any) => ({
        value: acc.account_code,
        label: `${acc.account_title} - ${acc.account_no}`,
        account_no: acc.account_no,
        account_title: acc.account_title,
        account_purpose: acc.account_purpose || [],
        ...acc,
      }));

      setFundAccountsMap((prev) => accounts);

      findCollectionAccount(accounts);
      return accounts;
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message ||
          `Failed to load accounts for fund ${fundCode}`
      );
      return [];
    }
  };

  const fetchFundMonthlyContribution = async (profit_month: string) => {
    try {
      const checkMonthlyContributionExists = await getAllProvidentFunds(
        email,
        "",
        fund,
        "",
        profit_month,
        profit_month,
        "",
        "true"
      );

      if (checkMonthlyContributionExists.data.total_records > 0)
        setErrorProfitMonth("");
      else
        setErrorProfitMonth(
          "Kindly Select month where Fund Contribution exists"
        );
    } catch (error) {}
  };

  useEffect(() => {
    if (fund) {
      const fetchFundContributionTotalsForMonth = async () => {
        try {
          const response = await getProvidentFundProfitSummary(
            email,
            amc_code,
            fund,
            ""
          );

          await fetchFundMonthlyContribution(profitMonth);

          if (response.data.status === 200) {
            const totals = response.data.summary;
            if (!totals) return;
            setTotal({
              overall_employee_contribution: totals.total_employee_contribution,
              overall_employer_contribution:
                totals.total_employeer_contribution,
              overall_total: totals.overall_net_total,
              overall_profit: totals.total_profit,
            });
          }
        } catch (error) {}
      };

      fetchAccountsForFund(fund);
      getCounterFundAccountByFundName(fund);
      fetchFundContributionTotalsForMonth();
    }
  }, [fund]);

  useEffect(() => {
    if (!id || companyOptions.length === 0) return;

    const fetchTransactionData = async () => {
      try {
        setLoadingTransactionData(true);
        const response = await getInvestmentTransactionById(id);

        if (!response.data.success) {
          toast.error("Failed to fetch transaction");
          return;
        }

        const txn = response.data.data;

        /* =============================
         BASIC TRANSACTION DATA
      ============================== */

        setFund(txn.fund_code);
        setProfitMonth(txn.profit_month);
        setProfitInputs(txn.profit_inputs || {});
        setGrossProfit(txn.gross_amount?.toString() || "0");
        setPreviewSessionId(txn.txn_id);
        setLedgersPayload(JSON.parse(txn.ledgers || "[]"));
        setDate(moment(txn.settlement_date).format("YYYY-MM-DD"));
        setSettlementDate(moment(txn.settlement_date).format("YYYY-MM-DD"));

        /* =============================
         COMPANY (from companyOptions)
      ============================== */

        if (txn.company_code) {
          const selectedCompany = companyOptions.find(
            (c) => c.value === txn.company_code
          );

          if (selectedCompany) {
            setCompanyName(selectedCompany);
          }
        }
        /* =============================
         FUND ACCOUNT
      ============================== */

        if (txn.account_no) {
          const accounts = await fetchAccountsForFund(txn.fund_code);
          setFundAccount(
            accounts?.find((account) => account.account_no === txn.account_no)
          );
        }

        if (txn.profit_month)
          await fetchFundMonthlyContribution(txn.profit_month);

        /* =============================
         PREVIEW DATA (VIEW MODE)
      ============================== */

        if (txn.txn_id) {
          setPreviewSessionId(txn.txn_id);
          await loadPreviewData(txn.txn_id, 1);
          await loadPreviewSummary(txn.txn_id);
        }

        setLoadingTransactionData(false);
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch transaction");
        setLoadingTransactionData(false);
      }
      setLoadingTransactionData(false);
    };

    fetchTransactionData();
  }, [id, companyOptions]);

  // 1. Fetch Companies
  useEffect(() => {
    const fetchAllCompanies = async () => {
      try {
        const resp = await getAllCompanies({ email, fetch_all: "all" });
        if (resp.data.status === 200) {
          const options = resp.data.data.map((data: any) => ({
            ...data,
            value: data.company_code,
            label: `${data.name_of_company} (${data.company_code})`,
          }));
          setCompanyOptions(options);
        }
      } catch (error) {
        toast.error("Failed to load companies");
      }
    };
    fetchAllCompanies();
  }, []);

  // 2. Fetch Funds when Company Changes
  useEffect(() => {
    const getAllFunds = async () => {
      if (!companyName?.value) {
        setAllFunds([]);
        return;
      }
      setAccFundLoading(true);
      try {
        const res = await getFunds({
          email,
          amc_code,
          company_name: companyName.value,
        });
        let sortedData = res.data.data.sort((a, b) =>
          a.nature > b.nature ? 1 : -1
        );
        setAllFunds(sortedData);
      } catch (error) {
        toast.error("Failed to load funds");
      }
      setAccFundLoading(false);
    };
    getAllFunds();
  }, [companyName]);

  useEffect(() => {
    if (!fund) return;
    fetchFundMonthlyContribution(profitMonth);
  }, [profitMonth]);

  // Helper function to get ledger info by code
  const getLedgerInfoByLedgerCode = (coa, ledgerCode) => {
    let obj = {};
    coa.forEach((item: any) => {
      item.family.forEach((familyF: any) => {
        familyF.sub_family.forEach((subfamily: any) => {
          if (subfamily.child_family !== undefined) {
            subfamily.child_family.forEach((itm: any) => {
              itm.gl.forEach((glItem: any) => {
                if (Number(glItem.code) === Number(ledgerCode)) {
                  obj = {
                    gl_code: glItem.code,
                    gl_name: glItem.name,
                    sub_family_code: subfamily.code,
                    sub_family_name: subfamily.name,
                    main_family_code: item.code,
                    main_family_name: item.name,
                    family_code: familyF.code,
                    family_name: familyF.name,
                    child_family_code: itm.code,
                    child_family_name: itm.name,
                  };
                }
              });
            });
          } else {
            subfamily.gl.forEach((glItem: any) => {
              if (Number(glItem.code) === Number(ledgerCode)) {
                obj = {
                  gl_code: glItem.code,
                  gl_name: glItem.name || glItem.account_title,
                  sub_family_code: subfamily.code,
                  sub_family_name: subfamily.name,
                  main_family_code: item.code,
                  main_family_name: item.name,
                  family_code: familyF.code,
                  family_name: familyF.name,
                  child_family_code: 0,
                  child_family_name: "",
                };
              }
            });
          }
        });
      });
    });
    return obj;
  };

  const handleProfitTransaction = async () => {
    setLoading(true);
    if (!fund || !fundAccount?.account_no) {
      toast.error("Please select Fund and Fund Account");
      setLoading(false);
      return;
    }
    if (parseFloat(grossProfit) <= 0) {
      toast.error("Profit amount must be greater than 0");
      setLoading(false);
      return;
    }

    if (ledgersPayload.length > 0) {
      fields.ledgers = JSON.stringify(ledgersPayload);
      fields.fund_code = fund;
      fields.net_amount = grossProfit.toString();
      fields.gross_amount = grossProfit.toString();
      fields.payment_type = "Receipt";

      fields.instruction_date = moment(date).format("YYYY-MM-DD");
      fields.execution_date = moment(date).format("YYYY-MM-DD");
      fields.executed_date = moment(date).format("YYYY-MM-DD");
      fields.settlement_date = moment(settlementDate).format("YYYY-MM-DD");
      fields.fund_account = `${fundAccount.account_title} - ${fundAccount.account_no}`;
      fields.account_no = fundAccount.account_no;
      fields.account_title = fundAccount.account_title;
      fields.bank = fundAccount.bank;
      fields.branch = fundAccount.branch;
      fields.detail = `${fund} Fund Profit Transaction`;

      try {
        const result = await addMegaTransaction({
          ...fields,
          profit_month: profitMonth,
          preview_session_id: previewSessionId,
          profit_inputs: profitInputs,
        });
        if (result.data.status === 200) {
          toast.success(`Transaction added. ID: ${result.data.txn_id}`);

          // Close preview modal
          setShowPreviewModal(false);

          setTimeout(() => {
            history.goBack();
          }, 1000);
        } else {
          toast.warning(result.data.message);
        }
      } catch (error) {
        console.log("ERROR => ", error);
        toast.error("Error submitting transaction");
      }
    } else {
      toast.error("Failed to create ledger entries");
    }
    setLoading(false);
  };

  // Update table data when profit amount changes
  useEffect(() => {
    if (!!id) return;
    if (
      !grossProfit ||
      parseFloat(grossProfit) <= 0 ||
      !fundAccount?.account_no ||
      chartOfAccounts.length === 0
    ) {
      setLedgersPayload([]);
      return;
    }

    const dateStr = moment(date).format("YYYY-MM-DD");

    const createLedgerEntryFromCode = (code, type, amount, amountType) => {
      const info: any = getLedgerInfoByLedgerCode(chartOfAccounts, code);

      return {
        main_family_code: info?.main_family_code,
        main_family_name: info?.main_family_name,
        family_code: info?.family_code,
        family_name: info?.family_name,
        sub_family_code: info?.sub_family_code,
        sub_family_name: info?.sub_family_name,
        child_family_code: info?.child_family_code,
        child_family_name: info?.child_family_name,
        gl_code: info?.gl_code,
        gl_name: info?.gl_name,
        amount_type: amountType,
        type: type,
        amc_code: amc_code,
        fund_code: fund,
        account_number: type === "Credit" ? fundAccount.account_no : "",
        account_title: type === "Credit" ? fundAccount.account_title : "",
        bank_code: type === "Credit" ? fundAccount.bank : "",
        branch: type === "Credit" ? fundAccount.branch : "",
        balance: "",
        counter_account_number: "",
        counter_account_title: "",
        counter_bank: "",
        counter_branch: "",
        credit_amount: type === "Credit" ? amount.toFixed(4) : "0",
        debit_amount: type === "Debit" ? amount.toFixed(4) : "0",
        description: `${amountType} - ${dateStr}`,
        entered_by: "",
        evidence: "",
        instruction_date: dateStr,
        instrument_by: "",
        instrument_date: dateStr,
        instrument_no: "",
        instrument_type: "",
        realized: "true",
        realized_by: "",
        realized_date: dateStr,
        period: sessionStorage.getItem("active_period") || "",
        paid: false,
      };
    };

    let assetCode: any = null;
    let liabilityCode: any = null;
    const employee_gl_code = 301030701;
    const employeer_gl_code = 301030702;
    const employeeProfit = parseFloat(
      (
        (parseFloat(grossProfit) * total.overall_employee_contribution) /
        total.overall_total
      ).toFixed(4)
    );

    for (const n of fundAccount.related_ledgers) {
      if (String(n).startsWith("1")) assetCode = n;
      else if (String(n).startsWith("5")) liabilityCode = n;
    }

    const payload = [
      // 1. Credit Bank Account
      createLedgerEntryFromCode(
        fundAccount.code,
        "Debit",
        parseFloat(grossProfit),
        "Bank Profit"
      ),
      createLedgerEntryFromCode(
        liabilityCode,
        "Credit",
        parseFloat(grossProfit),
        "Accrued Profit on Bank Deposit"
      ),
      createLedgerEntryFromCode(
        assetCode,
        "Debit",
        parseFloat(grossProfit),
        "ACCRUED RETURN"
      ),
      createLedgerEntryFromCode(
        employee_gl_code,
        "Credit",
        parseFloat(grossProfit),
        "Employee Contribution Profit"
      ),
    ];

    let totaldebit = 0,
      totalcredit = 0;
    payload.map((item: any) => {
      if (item.type === "Debit") {
        totaldebit += +item.debit_amount;
      }
      if (item.type === "Credit") {
        totalcredit += +item.credit_amount;
      }
    });

    setTotalDebit(totaldebit.toFixed(4).toString());
    setTotalCredit(totalcredit.toFixed(4).toString());
    setBalance((+totaldebit - +totalcredit).toFixed(4).toString());

    setLedgersPayload(payload);
  }, [grossProfit, fundAccount, chartOfAccounts, total]);

  useMemo(() => {
    const total = pf_profit_inputs.reduce((sum, investmentOption) => {
      const field_name = `${investmentOption
        .replace(" ", "_")
        .toLocaleLowerCase()}_profit`;
      return sum + (parseFloat(profitInputs[field_name]) || 0);
    }, 0);

    if (total !== parseFloat(grossProfit || 0)) {
      setGrossProfit(total.toString());
    }
  }, [profitInputs]);

  const renderFundsDropdown = () => {
    return allFunds.map((item: any) => {
      // eslint-disable-next-line
      if (item.nature === "Special Managed Account") {
        return {
          value: item.symbol_code,
          label: `${item.fund_name} (${item.symbol_code}) - SMA`,
        };
      } else {
        return {
          value: item.symbol_code,
          label: `${item.fund_name} (${item.symbol_code})`,
        };
      }
    });
  };

  const selectedFundName = React.useMemo(() => {
    const selected = allFunds.find((item) => item?.symbol_code === fund);
    return selected
      ? {
          value: selected.symbol_code,
          label: `${selected.fund_name} (${selected.symbol_code})${
            selected.nature === "Special Managed Account" ? " - SMA" : ""
          }`,
        }
      : null;
  }, [allFunds, fund]);

  const handleProfitInputs = (field_name, value) => {
    setProfitInputs((prev) => ({ ...prev, [field_name]: value }));
  };

  const fetchProfitPreview = async () => {
    if (!fund || !grossProfit || parseFloat(grossProfit) <= 0 || !profitMonth) {
      toast.error("Please fill all required fields");
      return;
    }

    if (errorProfitMonth) {
      toast.error(errorProfitMonth);
      return;
    }

    setPreviewLoading(true);
    try {
      // Generate preview
      const generateResponse = await profitPreviewAPI.generatePreview({
        company_code: companyName?.value,
        fund_code: fund,
        profit_month: profitMonth,
        profit_inputs: profitInputs,
      });

      if (generateResponse.data.status === 200) {
        const sessionId = generateResponse.data.preview_session_id;
        setPreviewSessionId(sessionId);
        toast.success("Preview generated successfully");

        // Fetch preview data
        await loadPreviewData(sessionId, 1);

        // Fetch summary
        await loadPreviewSummary(sessionId);

        // Show modal
        setShowPreviewModal(true);
      } else {
        toast.error(generateResponse.data.message);
      }
    } catch (error: any) {
      console.error("Error fetching preview:", error);
      toast.error(
        error?.response?.data?.message || "Failed to generate preview"
      );
    } finally {
      setPreviewLoading(false);
    }
  };

  const loadPreviewData = async (sessionId: string, page: number) => {
    try {
      setLoadingPreview(true);
      const response = await profitPreviewAPI.getPreview(sessionId, {
        page_number: page,
        page_size: pageSize,
        sortBy: "employee_code",
        order: "asc",
        search: searchTerm,
        status: !!id ? "committed" : "preview",
      });

      if (response.data.status === 200) {
        setPreviewData(response.data.data);
        setCurrentPage(response.data.page);
        setTotalPages(response.data.total_pages);
        setTotalRecords(response.data.total_records);
        setLoadingPreview(false);
      }
    } catch (error) {
      console.error("Error loading preview data:", error);
      toast.error("Failed to load preview data");
      setLoadingPreview(false);
    }
  };

  const loadPreviewSummary = async (sessionId: string) => {
    try {
      if (!sessionId) return;

      const summaryResponse = await profitPreviewAPI.getPreviewSummary(
        sessionId
      );

      if (summaryResponse.data.status !== 200) {
        console.error("Summary fetch failed:", summaryResponse.data);
        return;
      }

      const { overall_summary, investment_options } = summaryResponse.data;

      // Set the data
      setPreviewSummary(overall_summary);
      setInvestmentOptions(investment_options);
    } catch (error) {
      console.error("Error loading preview summary:", error);
    }
  };

  /**
   * Handle page change
   */
  const handlePageChange = (newPage: number) => {
    if (previewSessionId) {
      loadPreviewData(previewSessionId, newPage);
    }
  };

  /**
   * Handle search
   */
  const handleSearch = () => {
    if (previewSessionId) {
      loadPreviewData(previewSessionId, 1);
    }
  };

  const handleClosePreview = async () => {
    if (previewSessionId) {
      try {
        await profitPreviewAPI.deletePreview(previewSessionId);
      } catch (error) {
        console.error("Error deleting preview:", error);
      }
    }
    setSearchTerm("");
    setShowPreviewModal(false);
    setPreviewSessionId("");
    setPreviewData([]);
    setPreviewSummary(null);
  };

  if (loadingTransactionData)
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <i
          className="fa fa-spinner fa-spin"
          style={{ fontSize: "24px", color: "#007bff" }}
        ></i>
        <div>Loading Transaction data...</div>
      </div>
    );

  return (
    <>
      <ToastContainer limit={1} />
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <div className="input-holder">
                <div className="row">
                  <h4 className="card-title">
                    <i
                      className="fa fa-angle-left mr-2 ml-3 mt-1 pointer"
                      onClick={() => history.goBack()}
                    ></i>
                    Provident Fund Profit Distribution
                  </h4>
                </div>
              </div>
              <Row>
                {/* Card 1: Account Selection */}
                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Fund & Account Selection</h4>
                    </div>
                    <div className="card-body">
                      <div className="form-group">
                        <label>Company Name *</label>
                        <Select
                          isDisable={!!id}
                          options={companyOptions}
                          onChange={(e) => {
                            setCompanyName(e);
                            setFund("");
                          }}
                          value={companyName}
                          styles={customStyles}
                          menuPortalTarget={document.body}
                        />
                      </div>

                      <div className="form-group">
                        <label>Fund Name *</label>
                        {accFundLoading ? (
                          <div className="form-control w-100">
                            <i className="fa fa-spinner fa-spin"></i>
                          </div>
                        ) : (
                          <Select
                            options={renderFundsDropdown()}
                            onChange={(e) => {
                              setFund(e?.value);
                            }}
                            isDisable={!!id}
                            value={selectedFundName}
                            styles={customStyles}
                            menuPortalTarget={document.body}
                            isDisabled={!companyName}
                          />
                        )}
                      </div>

                      <div className="form-group">
                        <label>Fund Account*</label>
                        {counterFundLoading ? (
                          <div className="form-control w-100">
                            <i className="fa fa-spinner fa-spin fa-1x"></i>
                          </div>
                        ) : (
                          <Select
                            label={"Select"}
                            onChange={(e) => {
                              setFundAccount(e || {});
                            }}
                            value={fundAccount}
                            isClearable={true}
                            isSearchable={true}
                            options={fundAccountsMap}
                            styles={customStyles}
                            isDisable={!!id}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Card 2: Calculation Details */}
                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Profit Details</h4>
                    </div>
                    <div className="card-body">
                      <Row>
                        <Col className="form-group">
                          <label>Settlement Date</label>
                          <input
                            type="date"
                            className="form-control input_date"
                            value={date}
                            disabled={!!id}
                            onChange={(e) => {
                              setDate(e.target.value);
                              setSettlementDate(e.target.value);
                            }}
                          />
                        </Col>

                        <Col className="form-group">
                          <label htmlFor="pf-date">Profit Month</label>
                          <input
                            style={{
                              colorScheme: theme === "light" ? "light" : "dark",
                            }}
                            type="month"
                            className={`form-control py-1 ${
                              errorProfitMonth
                                ? "text-danger border-danger"
                                : ""
                            }`}
                            disabled={!!id}
                            value={profitMonth}
                            onChange={(e) => {
                              setProfitMonth(e.target.value);
                            }}
                          />
                          {errorProfitMonth && (
                            <span className="text-danger ">
                              {errorProfitMonth}
                            </span>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        {pf_profit_inputs.map((investmentOption) => {
                          const field_name = `${investmentOption
                            .replace(" ", "_")
                            .toLocaleLowerCase()}_profit`;

                          return (
                            <Col className="form-group">
                              <label>Profit on {investmentOption}</label>
                              <NumberFormat
                                className="form-control text-right"
                                value={profitInputs[field_name]}
                                disabled={!!previewSessionId}
                                thousandSeparator={true}
                                onValueChange={(values) => {
                                  handleProfitInputs(
                                    field_name,
                                    parseFloat(values.value)
                                  );
                                }}
                                placeholder={`Enter Profit on ${investmentOption} Amount`}
                              />
                            </Col>
                          );
                        })}
                      </Row>

                      <Row>
                        <Col className="form-group">
                          <label>Profit Amount (Gross)</label>
                          <NumberFormat
                            className="form-control text-right"
                            value={grossProfit}
                            disabled
                            thousandSeparator={true}
                            onValueChange={(values) => {
                              setGrossProfit(values.value);
                            }}
                            placeholder="Enter Profit Amount"
                          />
                        </Col>
                        {!id && (
                          <Col>
                            <button
                              className="btn btn-primary btn-block mt-4"
                              onClick={fetchProfitPreview}
                              disabled={
                                Loading ||
                                previewLoading ||
                                !!previewSessionId || // disable once preview exists
                                !grossProfit ||
                                parseFloat(grossProfit) <= 0
                              }
                            >
                              {previewLoading
                                ? "...Fetching"
                                : "Profit Preview"}
                            </button>
                          </Col>
                        )}
                      </Row>
                    </div>
                  </div>
                </Col>
              </Row>

              {ledgersPayload.length > 0 && (
                <Row>
                  <Col>
                    <div className="card">
                      <div className="card-header">
                        <h4 className="card-title text-primary">Ledgers</h4>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Ledger</th>
                                <th className="text-right">Debit Amount</th>
                                <th className="text-right">Credit Amount</th>
                                <th>Type</th>
                                <th>Ledger Family</th>
                              </tr>
                            </thead>

                            <tbody>
                              {ledgersPayload?.map(
                                (item: any, index: number) => {
                                  return (
                                    <tr>
                                      <td>
                                        <label>
                                          {item?.gl_name} <br />
                                          {item?.gl_code == "" ? (
                                            ""
                                          ) : (
                                            <small className="text-muted">
                                              ({item?.gl_code})
                                            </small>
                                          )}
                                        </label>
                                      </td>
                                      <td className="text-right">
                                        {numberWithCommas(item?.debit_amount)}
                                      </td>
                                      <td className="text-right">
                                        {numberWithCommas(item?.credit_amount)}
                                      </td>
                                      <td>{item?.type}</td>
                                      <td>{item?.main_family_name}</td>
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                            <tfoot>
                              <tr>
                                <td></td>
                                <td
                                  className={
                                    theme == "light"
                                      ? " text-dark " + " text-right"
                                      : " text-secondary" + " text-right"
                                  }
                                >
                                  Total Debit:{" "}
                                  <span className="text-primary">
                                    {numberWithCommas(totalDebit)}
                                  </span>
                                </td>
                                <td
                                  className={
                                    theme == "light"
                                      ? " text-dark " + " text-right"
                                      : " text-secondary" + " text-right"
                                  }
                                >
                                  Total Credit:{" "}
                                  <span className="text-primary">
                                    {numberWithCommas(totalCredit)}
                                  </span>
                                </td>
                                <td
                                  className={
                                    theme == "light"
                                      ? " text-dark " + " text-right"
                                      : " text-secondary" + " text-right"
                                  }
                                >
                                  Balance:{" "}
                                  <span className="text-primary">
                                    {numberWithCommas(balance)}
                                  </span>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              )}

              {previewSessionId && (
                <Row className="mt-4">
                  <Col md="12">
                    <div className="card">
                      <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title">
                          Profit Distribution Preview
                        </h4>

                        {!id && (
                          <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={handleClosePreview}
                          >
                            Cancel Preview
                          </button>
                        )}
                      </div>

                      <div className="card-body">
                        <ProfitPreviewCard
                          overallSummary={previewSummary}
                          investmentOptions={investmentOptions}
                          fund={fund}
                          profitMonth={profitMonth}
                          report={false}
                          reportName=""
                        />

                        {/* ===== Search ===== */}
                        <Row className="my-3">
                          <Col md="6">
                            <Row>
                              <Col>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search by employee code or name..."
                                  value={searchTerm}
                                  onChange={(e) =>
                                    setSearchTerm(e.target.value)
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") handleSearch();
                                  }}
                                />
                              </Col>
                              <Col>
                                <button
                                  className="btn btn-primary btn-block"
                                  onClick={handleSearch}
                                >
                                  {loadingPreview ? "Searching..." : "Search"}
                                </button>
                              </Col>
                            </Row>
                          </Col>

                          <Col md="6" className="text-right text-muted">
                            Showing {previewData.length} of {totalRecords}{" "}
                            records
                          </Col>
                        </Row>

                        {/* ===== Table ===== */}
                        <div className="table-responsive">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th>Employee Code</th>
                                <th>Employee Name</th>
                                <th>Investment Option</th>
                                <th className="text-right">Employee</th>
                                <th className="text-right">Employer</th>

                                <th className="text-right">Current Total</th>
                                <th className="text-right">Profit</th>
                                <th className="text-right">New Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {previewData.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.employee_code}</td>
                                  <td>{item.employee_name}</td>
                                  <td>{item.investment_option || "-"}</td>
                                  <td className="text-right">
                                    {numberWithCommas(
                                      item.employee_contribution?.toFixed(2)
                                    )}
                                  </td>
                                  <td className="text-right">
                                    {numberWithCommas(
                                      item.employer_contribution?.toFixed(2)
                                    )}
                                  </td>
                                  <td className="text-right">
                                    {numberWithCommas(
                                      item.net_total?.toFixed(2)
                                    )}
                                  </td>
                                  <td className="text-right text-success">
                                    {numberWithCommas(
                                      item.profit_amount?.toFixed(2)
                                    )}
                                  </td>
                                  <td className="text-right text-primary">
                                    {numberWithCommas(
                                      item.new_total?.toFixed(2)
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        {/* ===== Pagination ===== */}
                        {totalPages > 1 && (
                          <div className="d-flex justify-content-between align-items-center mt-4">
                            <button
                              className="btn btn-sm"
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              <i className="fa fa-chevron-left mr-2"></i>
                              Previous
                            </button>

                            <div className="d-flex gap-2">
                              {[...Array(totalPages)].map((_, i) => (
                                <button
                                  key={i}
                                  className={`btn btn-sm ${
                                    currentPage === i + 1
                                      ? "btn-primary"
                                      : "btn-outline-secondary"
                                  }`}
                                  onClick={() => handlePageChange(i + 1)}
                                >
                                  {i + 1}
                                </button>
                              ))}
                            </div>

                            <button
                              className="btn btn-sm"
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            >
                              Next
                              <i className="fa fa-chevron-right ml-2"></i>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              )}

              {!id && (
                <Row>
                  {/* Card 3: Ledger Preview */}
                  <Col md="4">
                    <button
                      className="btn btn-primary btn-block mt-3"
                      onClick={handleProfitTransaction}
                      disabled={
                        !previewSessionId ||
                        Loading ||
                        !grossProfit ||
                        parseFloat(grossProfit) <= 0
                      }
                    >
                      {Loading ? "Processing..." : "Submit Transaction"}
                    </button>
                  </Col>
                </Row>
              )}
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default PFProfitTransaction;
